import { defineStore } from "pinia";

export interface IConfigState {
  identity: {
    authority: string;
    MDMFrontendClientId: string;
  };
  mdm: {
    apiUrl: string;
  };
  strax: {
    url: string;
  };
  env: string;
}

enum Getters {
  ApiUrl = "ApiUrl",
}

export const useConfigStore = defineStore("config", {
  state: (): IConfigState => {
    return {
      identity: {
        authority: "",
        MDMFrontendClientId: "",
      },
      mdm: {
        apiUrl: "",
      },
      strax: {
        url: "",
      },
      env: "",
    };
  },
  getters: {
    [Getters.ApiUrl]: (state) => state.mdm.apiUrl,
    // Add a computed getter for headlineStyle
    headlineStyle: (state) => {
      return {
        color:
          {
            Prod: "#066b43", // Green for Prod
            PreProd: "#FFD700", // Yellow for PreProd
            Dev: "#FF0000", // Red for Dev
            Test: "#FF0000", // Red for Test
          }[state.env] || "#066b43", // Default to Green if environment is not recognized
      };
    },
  },
  actions: {
    initializeConfig(): Promise<any> {
      return fetch("/config.json").then(async (response) => {
        if (!response.ok) {
          throw new Error("HTTP error: " + response.status);
        }
        const config = (await response.json()) as IConfigState;
        if (config) {
          this.identity.authority = config.identity?.authority;
          this.identity.MDMFrontendClientId = config.identity?.MDMFrontendClientId;
          this.mdm.apiUrl = config.mdm.apiUrl;
          this.strax.url = config.strax?.url ?? "https://strax-gtdev.oesdev.net/";
          this.env = config.env;
        }
      });
    },
  },
});
